var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      staticClass: "tool",
      attrs: { id: "tool_" + _vm._uid, "data-tip": _vm.tip },
      on: { mouseover: _vm.hover },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }